export default {
  init() {
    // JavaScript to be fired on all pages

      /* eslint-disable */

    $('.menu-toggle').click(function () {
      $('.sidenav').toggleClass('sidenav_open');
      $('body').toggleClass('stop-scroll');
    });

      $('.mobile-dropdown').click(function () {
          $(this).next().toggleClass('mobile-submenu_active');
          $(this).find('.mobile-dropdown-arrow').toggleClass('mobile-dropdown-arrow_active');
      });

      $('.phone-toggle').click(function () {
          $('.phone-submenu').toggleClass('phone-submenu_active');
      });

      $(document).mouseup(function(e)
      {
          var container = $('.phone-submenu');

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
              container.removeClass('phone-submenu_active');
          }
      });

      $('.shortlist-toggle').click(function () {
          $('.shortlist-container').toggleClass('shortlist-container_open');
      });

      var rightCount = 1;
      $('.slider-arrow-right').click(function (event) {
          event.preventDefault();
              $('#slides').css({
                  '-webkit-transform': 'translateX(' + (-100 * rightCount) + 'vw) ',
              });
                leftCount = 0;
              rightCount += 1;
      });

      var leftCount = 1;
      $('.slider-arrow-left').click(function (event) {
          event.preventDefault();
          $('#slides').css({
              '-webkit-transform': 'translateX(' + (+100 * leftCount) + 'vw) ',
          });
          rightCount = 0;
          leftCount += 1;
      });

    $('.tabs-single').click(function(){
      $('.tabs-single').removeClass('tabs-single_active');
      $(this).addClass('tabs-single_active');
      $('.tab-content-single').hide();
    });

    $('.tab-content-2, .tab-content-3, .tab-content-4, .tab-content-5, .tab-content-6, .tab-content-7').hide();

    $('.tab-1').click(function(){
      $('.tab-content-1').show();
    });

    $('.tab-2').click(function(){
      $('.tab-content-2').show();
    });

    $('.tab-3').click(function(){
      $('.tab-content-3').show();
    });

    $('.tab-4').click(function(){
      $('.tab-content-4').show();
    });

    $('.tab-5').click(function(){
      $('.tab-content-5').show();
    });

    $('.tab-6').click(function(){
      $('.tab-content-6').show();
    });

    $('.tab-7').click(function(){
      $('.tab-content-7').show();
    });

    $('.pills-single').click(function () {

      if($(this).find('a').attr('data-slug') === 'all') {
        $('.pills-single').removeClass('pills-single_selected')
      }else{
        $('a[data-slug=all]').parent().removeClass('pills-single_selected');
      }

      $(this).toggleClass('pills-single_selected');
    });

    $('.pills-slideRight').click(function (event) {
      event.preventDefault();
      $('.pills').animate({
        scrollLeft: '+=800',
      }, 'fast');
      $('.pills-slideLeft').addClass('flex');
      $('.pills-slideLeft').removeClass('hidden');
    });

    $('.pills-slideLeft').click(function (event) {
      event.preventDefault();
      $('.pills').animate({
        scrollLeft: '-=800',
      }, 'fast');
    });

    $('.accordion-single_header').click(function () {
      $(this).next().toggleClass('accordion-single_body_open');
    });

    var acc = document.getElementsByClassName('accordion-header');
    var i;

    if(acc.length > 0){
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function () {
          this.classList.toggle('accordion-active');
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      }
    }


    /* When the user clicks on the button,
    toggle between hiding and showing the dropdown content */
    $('.dropbtn').click(function () {
      $(this).next().toggleClass('show');
    });

    // Close the dropdown menu if the user clicks outside of it
    window.onclick = function (event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName('dropdown-content');
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }

    var coll = document.getElementsByClassName('expand-collapse-button');

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function () {
        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }

    $('.expand-collapse-button').click(function () {
      $(this).text($(this).text() == 'Show Less' ? 'Show More' : 'Show Less');
    });

    // Leeds modal on contact page
    $('#myBtnLeeds').click(() => {
      $('#myModalLeeds').style.display = 'grid';
    });

    $('#closeLeeds').click(() => {
      $('#myModalLeeds').style.display = 'none';
    })

    $('#myModalLeeds').click(() => {
      $(this).hide();
    });

    // Newcastle modal on contact page
    $('#myBtnNewcastle').click(() => {
      $('#myModalNewcastle').style.display = 'grid';
    })

    $('#closeNewcastle').click(() => {
      $('#myModalNewcastle').style.display = 'none';
    });

    $('#myModalNewcastle').click(() => {
      $(this).hide();
    });

    function setLoadingBarristers() {

      $('.barristers-grid').html('<div>Loading</div>');

    }

    function filterResults(event) {

      const expertise = [];

      $('.pills-single_selected').each(function() {
        expertise.push($(this).find('a').data('slug'));
      });

      if(expertise.length === 0) {
        expertise.push('all')
      }

      if(event.type !== 'keyup' && expertise.includes('all')) {
        $('.barrister-search').val('');
      }

      let searchQuery = $('.barrister-search').val();

      if(typeof searchQuery !== 'undefined') {
        searchQuery = searchQuery.toLowerCase();
      }

      $('.barristers-single_card').each(function() {

        const barrister = $(this);

        let showBarrister = true;

        // Check the search query
        const barristerName = barrister.data('name').toLowerCase();

        if(!barristerName.includes(searchQuery)){
          showBarrister = false;
        }

        // Checks to see if there are any similarities between the selected filters an barrister
        const barristerExpertise = barrister.data('expertise');

        if(!Array.isArray(barristerExpertise)) {
          showBarrister = false;
        }else if(expertise.length !== 0 && !expertise.includes('all') && !expertise.every(item => barristerExpertise.includes(item))){
          showBarrister = false;
        }

        barrister.css('display', showBarrister ? 'block' : 'none');

      });

    }

    function getBarristers(args = []) {

      setLoadingBarristers()

      let url = ajaxUrl+'?action=barristers';

      url += '&orderBy=' + $('input[name=sort]:checked').val();

      const expertise = $('.barristers-grid').attr('data-expertise');

      if(typeof expertise !== 'undefined') {
        url += '&expertise=' + expertise;
      }

      $.get(url).done(function (response) {
        $('.barristers-grid').html(response);

        if(typeof expertise === 'undefined') {
          filterResults();
        }
      });

    }

    setLoadingBarristers()
    getBarristers();

    $('input[name=sort]').change(getBarristers)
    $('.barrister-filter').on('click keyup', filterResults);

    // Wishlist barrister
    $(document).on("click", '.add-to-shortlist', function (event) {

      event.preventDefault();

      let wishlistStorage = localStorage.getItem('wishlist');

      wishlistStorage = wishlistStorage === null
        ? []
        : JSON.parse(wishlistStorage);

      const element = $(this);
      const barristerName = element.attr('data-name');
      const barristerId = element.attr('data-id');
      const expertise = element.data('expertise')

      const barristerExists = wishlistStorage.filter(item => {
        return item.name === barristerName;
      }).length > 0;

      if(barristerExists) {
        return;
      }

      wishlistStorage.push({
        name: barristerName,
        id: barristerId,
        expertise: expertise
      });

      localStorage.setItem('wishlist', JSON.stringify(wishlistStorage));

      populateWishList();

      $('.shortlist-container').show()
      $('.shortlist-container').addClass('shortlist-container_open')

    });

    $(document).on("click", '.remove-from-wishlist', function (event) {

      let wishlistStorage = localStorage.getItem('wishlist');

      if(wishlistStorage === null) {
        return;
      }

      wishlistStorage = JSON.parse(wishlistStorage);

      if(!Array.isArray(wishlistStorage) || wishlistStorage.length === 0) {
        return;
      }

      const element = $(this);
      const barristerId = element.data('id');

      let keyToDelete = false;

      wishlistStorage.forEach((item, key) => {
        console.log(item.id, barristerId)
        if(item.id == barristerId){
          keyToDelete = key;
        }
      });

      wishlistStorage.splice(keyToDelete, 1)

      localStorage.setItem(
        'wishlist',
        JSON.stringify(wishlistStorage)
      );

      populateWishList();

    });

    function populateWishList() {

      $('#wishlistItems').html('');
      $('.shortlistCount').html(0)

      let wishlistStorage = localStorage.getItem('wishlist');

      if(wishlistStorage === null) {
        return;
      }

      wishlistStorage = JSON.parse(wishlistStorage);

      if(!Array.isArray(wishlistStorage) || wishlistStorage.length === 0) {
        return;
      }

      let html = '';

      wishlistStorage.forEach(item => {

        const nameSlug = item.name.toLowerCase()
          .replace(/ /g,'-')
          .replace(/[^\w-]+/g,'');

        html += '<div class="flex items-center gap-16 justify-between wishlist-'+nameSlug+'">' +
          '                <div>' +
          '                    <h4 class="font-normal normal-case mb-0">'+item.name+'</h4>' +
          '                </div>' +
          '                <div class="flex gap-4">' +
          '                    <a target="_blank" data-id="'+item.id+'" class="download-all flex flex-col items-center text-teal hover:bg-teal hover:bg-opacity-10 transition-all duration-200 px-3 py-2 rounded">' +
          '                        <svg height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(4 3)"><path d="m2.5 7.5 4 4.232 4-4.191"/><path d="m6.5.5v11"/><path d="m.5 14.5h12"/></g></svg>' +
          '                        <span>Download</span>' +
          '                    </a>' +
          '                    <button class="flex flex-col items-center text-orange hover:bg-orange hover:bg-opacity-10 transition-all duration-200 px-3 py-2 rounded remove-from-wishlist" data-id="'+item.id+'">' +
          '                        <svg height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(3 2)"><path d="m2.5 2.5h10v12c0 1.1045695-.8954305 2-2 2h-6c-1.1045695 0-2-.8954305-2-2zm5-2c1.0543618 0 1.91816512.81587779 1.99451426 1.85073766l.00548574.14926234h-4c0-1.1045695.8954305-2 2-2z"/><path d="m.5 2.5h14"/><path d="m5.5 5.5v8"/><path d="m9.5 5.5v8"/></g></svg>' +
          '                        <span>Delete</span>' +
          '                    </button>' +
          '                </div>' +
          '            </div>';

        const barristerId   = item.id;
        const expertiseObject = item.expertise;

        if(Array.isArray(expertiseObject)) {

          const dontAllowExpertise = [
            'Executive Management',
            'Service Company',
          ];

          expertiseObject.forEach(item => {

            if(dontAllowExpertise.includes(item.name)) {
              return;
            }

            html += '<div class="expertise-'+barristerId+' '+barristerId+'-'+item.term_id+'">' +
              '<div class="flex justify-between">' +
              '   <div>'+item.name+'</div>' +
              '   <div>' +
              '     <button class="flex flex-col items-center text-orange hover:bg-orange hover:bg-opacity-10 transition-all duration-200 px-3 py-2 rounded remove-expertise-from-wishlist" onclick="removeExpertiseFromWishlist('+barristerId+','+item.term_id+')">' +
              '       <svg height="18" viewBox="0 0 25 25" width="18" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(3 2)"><path d="m2.5 2.5h10v12c0 1.1045695-.8954305 2-2 2h-6c-1.1045695 0-2-.8954305-2-2zm5-2c1.0543618 0 1.91816512.81587779 1.99451426 1.85073766l.00548574.14926234h-4c0-1.1045695.8954305-2 2-2z"/><path d="m.5 2.5h14"/><path d="m5.5 5.5v8"/><path d="m9.5 5.5v8"/></g></svg>' +
              '    </button>' +
              '   </div>' +
              '</div>' +
              '</div>';
          })
        }

      });

      $('#wishlistItems').html(html)
      $('.shortlistCount').html(wishlistStorage.length > 0 ? wishlistStorage.length : 0);

    }

    populateWishList();

    // get posts
    function getPosts() {

      const moreNewsElement = $('#more-news');

      if(typeof moreNewsElement === 'undefined') {
        return;
      }

      let pageNumber = Number(moreNewsElement.attr('data-page'));
      let loading = moreNewsElement.attr('data-loading');

      if(loading == 'true') {
        return;
      }

      $.get({
        url: ajaxUrl+'?action=get_posts&paged='+pageNumber,
        beforeSend: function(){
          moreNewsElement.attr('data-loading', 'true');
        }
      }).done(function (response) {
          moreNewsElement.append(response);
          moreNewsElement.attr('data-page', pageNumber + 1)
          moreNewsElement.attr('data-loading', 'false');
        });
    }

    $(window).scroll(function () {
      if ($(window).scrollTop() > $('#more-news').height() / 2) {
        getPosts();
      }
    });


    getPosts();

    function getCategoryPosts(element) {

      let pageNumber = Number(element.attr('data-page'));
      let loading = element.attr('data-loading');
      let category = element.attr('data-type');

      if(loading == 'true') {
        return;
      }

      $.get({
        url: ajaxUrl+'?action=get_posts&paged='+pageNumber+'&category='+category,
        beforeSend: function(){
          element.attr('data-loading', 'true');
        }
      }).done(function (response) {
        element.append(response);
        element.attr('data-page', pageNumber + 1)
        element.attr('data-loading', 'false');
      });

    }

    const getPostsElements = $('.get-posts');

    getPostsElements.each(function () {

      const element = $(this);

      getCategoryPosts(element);

        $(window).scroll(function () {
          if ($(window).scrollTop() > element.height() / 2) {
            getCategoryPosts(element);
          }
        });



    });

      /* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js